/**
 * LeadFactsRow — compact job facts without card chrome.
 */

import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { getLeadFactsRowModel } from "../services/leadValueProviders.js";

const LeadFactsRow = ({ lead, quote = null }) => {
  const facts = useMemo(() => getLeadFactsRowModel(lead, quote), [lead, quote]);

  return (
    <Box
      data-testid="lead-facts-row"
      display="grid"
      gridTemplateColumns={{
        xs: "repeat(2, minmax(0, 1fr))",
        sm: "repeat(4, minmax(0, 1fr))",
      }}
      gap={2}
      sx={{
        mb: 2,
        px: { xs: 0.5, md: 1 },
        py: 1.5,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      {facts.map((fact) => (
        <Box key={fact.key} minWidth={0}>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            sx={{ fontWeight: 600, mb: 0.25 }}
          >
            {fact.label}
          </Typography>
          <Typography variant="body2" fontWeight={600} noWrap title={fact.value}>
            {fact.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default LeadFactsRow;
